export const useListen = (controller) => {
  const controllerDisconnect = controller.disconnect.bind(controller)
  controller.eventTarget ??= new EventTarget();

  const listen = (eventName, callback, target = controller.eventTarget) => {
    // This allows passing a controller as the target
    if (target?.eventTarget !== undefined) target = target.eventTarget
    const boundCallback = (evt) => callback.bind(controller)(evt?.detail || evt);
    target.addEventListener(eventName, boundCallback);
    controller._removeListeners ??= [];
    controller._removeListeners.push(() => target.removeEventListener(eventName, boundCallback));
  }

  const listenWindow = (eventName, callback) => {
    listen(eventName, callback, window);
  }

  const emit = (eventName, detail = {}, target = controller.eventTarget) => {
    target.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  const emitWindow = (eventName, detail = {}) => {
    emit(eventName, detail, window);
  }

  const disconnect = () => {
    if (controller._removeListeners) {
      controller._removeListeners.forEach(remove => remove());
      controller._removeListeners = [];
    }
  }

  Object.assign(controller, {
    listen, listenWindow, emit, emitWindow,
    disconnect() {
      disconnect()
      controllerDisconnect()
    }
  })
}
